import { Asset } from '@/types/models/assets.types';

/**
 * Formats the asset display name based on asset type.
 * For mobile assets: "asset_ui_name - asset_supplier asset_model" (e.g., "22913 - Komatsu 930E")
 * For fixed assets: "asset_ui_name"
 */
export const formatAssetName = (asset: Asset | undefined, isMobileAsset: boolean): string => {
  if (!asset) return '';
  const { asset_ui_name, asset_supplier, asset_model } = asset;
  if (isMobileAsset && asset_supplier && asset_model) {
    return `${asset_ui_name} - ${asset_supplier} ${asset_model}`;
  }
  return asset_ui_name || '';
};
